import React from 'react';

type Props = {
  className?: string;
  width?: number | string;
  height?: number | string;
};

const Icon: React.FC<Props> = ({ className, width, height }: Props) => (
  <svg
    x="0"
    y="0"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 512 512"
    enableBackground="new 0 0 512 512"
  >
    <g>
      <path
        fill="#AAAAAA"
        d="M0,48v416h512V48H0z M480,432H32V80h448V432z M352,160c0,26.51,21.49,48,48,48s48-21.49,48-48   s-21.49-48-48-48S352,133.49,352,160z M448,400H64l96-256l128,160l64-48L448,400z"
      />
    </g>
  </svg>
);

export default Icon;
